import { createTheme } from "@mui/material";
import { common } from "@mui/material/colors";
import { Colors, PrimaryColors } from "../../style/colors";
import { BACKGROUND, FONT_FAMILY, INHERIT_DEFAULT1, INHERIT_DEFAULT2, SECONDARY } from "./constant";
import { MuiButton } from "./overrides/mui-button";
import { MuiPaper } from "./overrides/mui-paper";
import { MuiTypography } from "./overrides/mui-typography";

// Colors, fonts and the Button, Paper and Typography overrides are POM's; its remaining ~25
// component overrides cover accordions, steppers and dialogs this page never renders.
export const appTheme = createTheme({
  typography: {
    fontFamily: FONT_FAMILY,
  },
  palette: {
    background: {
      default: BACKGROUND,
    },
    primary: {
      main: PrimaryColors.base,
      contrastText: common.white,
    },
    grey: {
      300: INHERIT_DEFAULT1,
      A100: INHERIT_DEFAULT2,
    },
    secondary: {
      main: SECONDARY,
      contrastText: common.white,
    },
    error: {
      main: Colors.red,
    },
    success: {
      main: Colors.accentGreenLight,
    },
    warning: {
      main: Colors.orange,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton,
    MuiPaper,
    MuiTypography,
  },
});
